import { Node, mergeAttributes } from "@tiptap/core";

export const VideoNode = Node.create({
  name: "video",
  group: "block",
  atom: true,
  draggable: true,
  addAttributes() {
    return { src: { default: null } };
  },
  parseHTML() {
    return [{ tag: "video[src]" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["video", mergeAttributes(HTMLAttributes, { controls: "true", playsinline: "true", preload: "metadata" })];
  },
  addCommands() {
    return {
      setVideo: (attrs) => ({ commands }) => commands.insertContent({ type: this.name, attrs }),
    };
  },
});
